import {
  ProductPriceInfo,
  productPriceInfoFromResponse,
} from '../Product/ProductPriceInfo';

export interface BasketOptionItem {
  optionValueID: string;
  label: string;
  specialPrice: number;
  price: ProductPriceInfo;
}

export const basketOptionItemFromResponse = (
  responseData: any,
): BasketOptionItem => ({
  optionValueID: responseData.option_value_id,
  label: responseData.label,
  specialPrice: responseData.special_price,
  price: productPriceInfoFromResponse(responseData.price),
});

export interface BasketOption {
  item: BasketOptionItem;
}

export const basketOptionFromResponse = (responseData: any): BasketOption => ({
  item: basketOptionItemFromResponse(responseData.item),
});
